export default __webpack_public_path__ + "static/media/custimage1.745c86900082ea2f3d28a403bae8b1f7.png";